import { render } from "./FeatInfoEvent.vue?vue&type=template&id=c38eaff4&scoped=true"
import script from "./FeatInfoEvent.vue?vue&type=script&lang=js"
export * from "./FeatInfoEvent.vue?vue&type=script&lang=js"

import "./FeatInfoEvent.vue?vue&type=style&index=0&id=c38eaff4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c38eaff4"]])

export default __exports__